const usagesSalles = [
  { tag: "usageSalle1", color: "#6f6456" },
  { tag: "usageSalle2", color: "#cddc49" },
  { tag: "usageSalle3", color: "#cb7e94" },
  { tag: "usageSalle4", color: "#e94b30" },
  { tag: "usageSalle5", color: "#fee659" },
  { tag: "usageSalle6", color: "#a1cfdd" },
  { tag: "usageSalle7", color: "#043a33" },
  { tag: "usageSalle8", color: "#d6e2d2" },
  { tag: "usageSalle9", color: "#869855" },
  { tag: "usageSalle10", color: "#e4d19b" },
  { tag: "usageSalle11", color: "#9b5427" },
  { tag: "usageSalle12", color: "#a6c087" },
  { tag: "usageSalle13", color: "#00654b" },
  { tag: "usageSalle14", color: "#fed18e" },
  { tag: "usageSalle15", color: "#af2511" },
];

export { usagesSalles };
